import append from 'ramda/src/append'

export default function favoriteModel(state, action) {
  const { id, controllerModel } = action
  const key = controllerModel ? 'favoriteDoorControllerModels' : 'favoriteModels'

  if (state[key].includes(id)) return state

  return Object.assign({}, state, {
    [key]: append(id, state[key])
  })
}



// WEBPACK FOOTER //
// ./src/reducers/favoriteModel.js